import { ErrorMessage, Field, Form, Formik } from 'formik'

import config from '../../../config.json'
import * as Yup from 'yup';
import { sanitizeFormInput, sanitizeFormOutput } from '../../../functions/formFunctions'
import FieldWrapper from '../../forms/FieldWrapper'
import ButtonSubmitCancel from '../../general/ButtonSubmitCancel'
import WrapperAccordion from '../../general/WrapperAccordion'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import MultiselectCheckboxCinemas from '../../forms/fields/MultiselectCheckboxCinemas';
import { withRouter } from 'react-router';
import { WEISCHER_MAIN, WEISCHER_OVERVIEW, WEISCHER_PREROLL, WEISCHER_INTERSCROLLER, WEISCHER_OVERVIEW_HERO } from '../../../constants/weischerTypes';
import sortCinemas from '../../../functions/sortCinemas';
import ImageDisplayAndUpload from '../../forms/fields/ImageDisplayAndUpload';
import Translation from '../../Translation/cont/Translation';
import addFormikData from '../../../functions/addFormikData';
import RadioButtonGroup from '../../forms/fields/RadioButtonGroup';
import RadioButton from '../../forms/fields/SingleSelectRadiobutton';
import attributeConfig from '../../../attribute-position-config.json'

const EditWeischerAd = ({itemData, history, onUpdateItem, cliCinemas, weischerType, closePagePath, clientCinemaId}) => {
    if(!itemData) {
        return ''
    }

    const formTitle = weischerType === WEISCHER_MAIN ? <Translation id="program_edit_weischer_form_title_main"/> : weischerType === WEISCHER_PREROLL ? <Translation id="program_edit_weischer_form_title_preroll"/> : weischerType === WEISCHER_OVERVIEW ? <Translation id="program_edit_weischer_form_title_overview"/> : weischerType === WEISCHER_OVERVIEW_HERO ? <Translation id="program_edit_weischer_form_title_hero"/> : weischerType === WEISCHER_INTERSCROLLER ? <Translation id="program_edit_weischer_form_title_interscroller"/> : ''
    const pageName = itemData && itemData.payload ? <p><Translation id="program_edit_weischer_advertising_element"/> {itemData.payload}</p> : <Translation id="program_list_button_new_ad" />
    const cinemaDomain = cliCinemas[clientCinemaId] && cliCinemas[clientCinemaId].website
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    const {destinationType, pathType} = attributeConfig
    const payloadTitle = weischerType === WEISCHER_PREROLL ? 'URL*' : 'ID*'
    const newLinkData = {
        destinationType: "internal",
        pathType: "absolute",
        url: "",
        text: ""
    }
    const linkData = itemData && itemData.fallbackLink ? itemData.fallbackLink : newLinkData
    const validationSchema = Yup.object().shape({
        payload: Yup.string()
            .required(<Translation id="formik_id_required"/>),
    });

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page site-content">
                <Formik
                initialValues={addFormikData(sanitizeFormInput(itemData, cliCinemas), linkData, "fallbackLink")}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    values.type = weischerType
                    if(weischerType === WEISCHER_MAIN) {
                        values.active = true
                    }
                    
                    if(!values.fallbackLink.url) {
                        addFormikData(values, "", "fallbackLink")
                    }

                    onUpdateItem(sanitizeFormOutput(values))
                    actions.setSubmitting(false)
                }}
                onReset={(values, actions) => {
                    history.push(closePagePath)
                }}>
                {({ values, errors, status, touched, isSubmitting, handleReset }) => (
                        <Form>
                            <WrapperAccordion
                                className="single-section"
                                selectionActiveClass="accordion-item-open"
                            >
                                <fieldset>
                                    <div className="form-content weischer">
                                        <div className="left-sections">
                                            <p className="title-large-light"><Translation id="program_edit_weischer_element"/> {formTitle}</p>
                                            <FieldWrapper label={"Element " + payloadTitle} id="weischer-id" classes="field-text">
                                                <Field type="text" name="payload" id="weischer-id" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="payload" component="div" /> 
                                            </FieldWrapper>
                                            {weischerType !== WEISCHER_PREROLL && weischerType !== WEISCHER_OVERVIEW && weischerType !== WEISCHER_INTERSCROLLER && <>
                                                <FieldWrapper classes="image" label={<Translation id="program_edit_weischer_image_element"/>} id="content-image" >
                                                    <Field 
                                                        name="fallbackImage"
                                                        component={ImageDisplayAndUpload}
                                                    />
                                                </FieldWrapper>
                                                <>
                                                    <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text gap-20">
                                                        <Field type="text" name="fallbackLink.url" id="content-link-url" className="text-regular input-text-box" />
                                                        <ErrorMessage name="fallbackLink.url" component="div" /> 
                                                    </FieldWrapper>
                                                    <RadioButtonGroup
                                                        label={<Translation id="content_link_target"/>}
                                                        description={<Translation id="content_link_target_info"/>}
                                                        className="select-new-section-type gap-20"
                                                    >
                                                        <ErrorMessage className="text-regular-color movie-error" name="fallbackLink.destinationType" component="div" /> 
                                                        {destinationType.map(type => {
                                                            const {transId, id} = type
                                                            return (
                                                                <Field
                                                                    key={id}
                                                                    component={RadioButton}
                                                                    name="fallbackLink.destinationType"
                                                                    id={id}
                                                                    label={<Translation id={transId}/>}
                                                                />
                                                            )
                                                        })}
                                                    </RadioButtonGroup>
                                                    <RadioButtonGroup
                                                        label={<Translation id="content_link_type"/>}
                                                        description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                                        className="select-new-section-type gap-20"
                                                    >
                                                        <ErrorMessage className="text-regular-color movie-error" name="fallbackLink.pathType" component="div" /> 
                                                        {pathType.map(type => {
                                                            const {transId, id} = type
                                                            return (
                                                                <Field
                                                                    key={id}
                                                                    component={RadioButton}
                                                                    name="fallbackLink.pathType"
                                                                    id={id}
                                                                    label={<Translation id={transId}/>}
                                                                />
                                                            )
                                                        })}
                                                    </RadioButtonGroup>
                                                </>
                                            </>}
                                            {_.has(values, "cinema") && cliCinemas ? (
                                                    cliCinemasIdList.length > 1 ? (
                                                        <fieldset className="field-cinemas">
                                                            <legend className="field-text-label">Kinos</legend>

                                                            <div className="select-all-cinemas-button-wrapper">  
                                                                <div key={'field-all'} className="field-checkbox">
                                                                    <Field 
                                                                        key={'all'} 
                                                                        attrid={'all'}
                                                                        name="cinemas"
                                                                        component={MultiselectCheckboxCinemas} 
                                                                        id={'alle anwählen'}
                                                                        clicinemas={'all'}
                                                                        value={cliCinemasIdList} 
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="grid-container">
                                                                {cliCinemasIdList.map(cinemaId => {
                                                                    const cinema = cliCinemas[cinemaId]
                                                                    const {pk, nameShort} = cinema

                                                                    return (
                                                                        <div key={'field' + pk} className="field-checkbox">
                                                                            <Field 
                                                                                key={pk} 
                                                                                attrid={pk}
                                                                                name="cinemas"
                                                                                component={MultiselectCheckboxCinemas} 
                                                                                id={nameShort}
                                                                                clicinemas={cliCinemas}
                                                                                value={pk} 
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </fieldset>
                                                    ) : (
                                                        cliCinemasIdList.map(cinemaId => {
                                                            const cinema = cliCinemas[cinemaId]
                                                            const {pk, nameShort} = cinema

                                                            return (
                                                                <div key={'field' + pk} className="field-checkbox">
                                                                    <Field 
                                                                        key={pk} 
                                                                        attrid={pk}
                                                                        name="cinemas"
                                                                        component={MultiselectCheckboxCinemas} 
                                                                        pk={nameShort}
                                                                        clicinemas={cliCinemas}
                                                                        value={pk}
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                    )
                                                ) : (
                                                    ''
                                                )
                                            }
                                        </div>
                                    </div>
                
                                    <ButtonSubmitCancel
                                        transIdCancel="cancel_button"
                                        transIdSubmit="save_promotional_button"
                                        disabledCancel={isSubmitting}
                                        disabledSubmit={isSubmitting}
                                        onCancel={handleReset}
                                    />
                                </fieldset>
                            </WrapperAccordion>
                        </Form>
                    )}

                </Formik>
            </div>
        </WrapperPageSimple>
    )
}

export default withRouter(EditWeischerAd)